import type { AccessResourceType } from '~/features/access-control/types/AccessControl';

import { clausewitz } from '~/services/serviceInstances';

import type { ResourceAccess } from './accessGrantMapper';
import type { ServerClauseAccessResponse } from './clauseAccessMapper';

import {
  getClauseAccessPath,
  isClauseLibraryAccessResourceType,
  mapClauseAccessResponse,
} from './clauseAccessMapper';

type Request = {
  resourceId: string;
  resourceType: AccessResourceType;
};

export const getClauseResourceAccess = async ({
  resourceId,
  resourceType,
}: Request): Promise<ResourceAccess> => {
  if (!isClauseLibraryAccessResourceType(resourceType)) {
    throw new Error(
      `getClauseResourceAccess does not support resourceType "${resourceType}"`,
    );
  }

  const serverResponse = await clausewitz.get<ServerClauseAccessResponse>(
    getClauseAccessPath(resourceType, resourceId),
  );

  return mapClauseAccessResponse(serverResponse);
};
